import { MobXProviderContext } from 'mobx-react'
import { useContext } from 'react'
import RootStore from 'stores/RootStore'

export type appContext = Record<string, RootStore>

export function useRootStore() {
  return useContext<appContext>(MobXProviderContext)
}
